import React, { useEffect, useState } from "react";

import { useStepContext } from "../../utils/StepContext.jsx";
import { useFormContext } from "../../utils/FormContext.jsx"; 


import MainCard from "../MainCard.jsx";

// ASSETS
import AvatarSVG from "../../assets/Avatar.jsx";
import BedroomSVG from "../../assets/Bedroom.jsx";
import MoneySVG from "../../assets/Money.jsx";
import SchoolSVG from "../../assets/School.jsx";
import PeopleSVG from "../../assets/People.jsx";
import TransactionSVG from "../../assets/Transaction.jsx";
const starEmoji = "⭐"; 
import { useMediaQuery } from 'react-responsive';

const NewResultsCard = () => {

    const { handleNext, handleBack } = useStepContext();
    const { formData, setFormData, propertyData } = useFormContext(); 
    const isMobile = useMediaQuery({ query: '(max-width: 768px)' });

    const [streetViewUrl, setStreetViewUrl] = useState('');
    const [propertyDescription, setPropertyDescription] = useState('');
    const [propertyCounty, setPropertyCounty] = useState('');
    const [exclusions, setExclusions] = useState(''); 
    const [seller1Name, setSeller1Name] = useState(''); 
    const [seller2Name, setSeller2Name] = useState(''); 
    const realieData = propertyData?.propertyDetails?.realieData;
    // console.log("Realie Data:", realieData);
    

    let address = Object.values(formData.address).join(', ');

    // console.log("Property Data:", propertyData.propertyDetails);

    const formatPrice = (price) => {
        return price 
            ? Math.round(price).toLocaleString('en-US', { style: 'currency', currency: 'USD' }).split('.')[0]
            : "Price not available";
    };
      
    const formatDate = (date) => {
        if (!date) return "Date not available";
        const [year, month, day] = date.split('-');
        const dateObj = new Date(year, month - 1, day);
        return dateObj.toLocaleString('en-US', { 
            year: 'numeric',
            month: 'long',
            day: 'numeric'
        });
    };

    function formatPhoneNumber(phoneNumberString) {
        const cleaned = ('' + phoneNumberString).replace(/\D/g, '');
        const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
        if (match) {
            return '(' + match[1] + ') ' + match[2] + '-' + match[3];
        }
        return null;
    }

    let listPrice = propertyData?.propertyDetails?.price;
    let taxPrice = propertyData?.propertyDetails?.taxHistory?.[0]?.taxPaid;
    let formattedPrice = formatPrice(listPrice);
    let formattedTaxPrice = formatPrice(taxPrice);
    let saleAmount1 = propertyData?.propertyDetails?.saleHistory?.[0]?.saleAmount;
    let formattedSaleAmount1 = formatPrice(saleAmount1);
    let saleAmount2 = propertyData?.propertyDetails?.saleHistory?.[1]?.saleAmount;
    let formattedSaleAmount2 = formatPrice(saleAmount2);
    let status = propertyData?.propertyDetails?.keystoneHomeStatus
        ? propertyData.propertyDetails.keystoneHomeStatus
            .replace(/([A-Z])/g, ' $1')
            .replace(/^./, str => str.toUpperCase())
            .trim()
        : 'Status not available';
    let homeImage = propertyData?.propertyDetails?.originalPhotos?.[0]?.mixedSources?.jpeg?.[0]?.url;
    let legalDescription = propertyData?.propertyDetails?.realieData?.property?.legalDesc; 
    let county = propertyData?.propertyDetails?.realieData?.property?.county;
    let exclusionsText = propertyData?.propertyDetails?.resoFacts?.exclusions?.[0];
    let ownerName = propertyData?.propertyDetails?.realieData?.property?.ownerName;

    const handleHomeSearch = () => {
        if (homeImage) {
          
            setStreetViewUrl(homeImage);
            setFormData(prevData => {
                const newData = { ...prevData, streetViewUrl: homeImage };
                return newData;
            }); 
        } else {
            console.log("No homeImage available to set");
        }
    };

    const handlePropertyInfo = () => {
        const updates = {};
        
        // Handle property details
        if (legalDescription) {
            updates.propertyDescription = legalDescription;
            setPropertyDescription(legalDescription);
        }
        
        if (county) {
            updates.propertyCounty = county;
            setPropertyCounty(county);
        }
        
        if (exclusionsText) {
            updates.exclusionsText = exclusionsText;
            setExclusions(exclusionsText);
        }

        // Handle seller names
        const names = ownerName.split(';').map(name => name.trim());
        
        // Set first seller name
        if (names[0]) {
            updates.seller1Name = names[0];
            setSeller1Name(names[0]);
        }
        
        // Set second seller name if it exists
        if (names[1]) {
            updates.seller2Name = names[1];
            setSeller2Name(names[1]);
        }

        // Only update formData if we have any updates
        if (Object.keys(updates).length > 0) {
            setFormData(prevData => ({
                ...prevData,
                ...updates
            }));
        } else {
            console.log("No property information available to set");
        }
    };
  
    useEffect(() => { 
        // console.log("useEffect triggered with propertyData:", propertyData);
        if (propertyData?.propertyDetails) {
            handleHomeSearch();
            handlePropertyInfo(); 
        }
    }, [propertyData, address]);

    const handleBuildOfferClick = () => {
        handleNext();
    };

    return (
        <div className="w-full flex flex-col items-center">
            <div className="flex flex-col justify-between overflow-y-auto md:max-h-[650px] max-h-[75vh] w-[350px] md:w-[750px] items-center">
                <div className="flex-col items-start gap-[10px] mb-2 flex w-[350px] md:w-[750px]">
                    {/* Add a check to see what's happening */}
                    {!propertyData?.propertyDetails ? (
                        <>
                            <h1 className="text-center text-black text-[20px] md:text-[28px] font-semibold font-['Inter']">Property Not Found</h1>
                            <span className="text-left text-slate-500 text-[16px] md:text-[18px] font-medium font-['Inter']">
                                We couldn't find data for this property. You can still build your offer, but you'll need to manually enter some information. You can return to this page to fill in the missing information at any time.
                            </span>
                        </>
                    ) : (
                        <>
                            <h1 className="text-center text-black text-[20px] md:text-[34px] font-semibold font-['Inter']">Found It!</h1>
                            <span className="text-center text-black text-[18px] md:text-2xl font-medium font-['Inter']">{Object.values(formData.address).join(', ')}</span>
                        </>
                    )}
                </div>
                <div className="w-full bg-white rounded-lg shadow-[rgba(0,0,0,.5)_-2px_2px_10px_-5px] max-h-[725px] md:max-h-[575px] overflow-y-auto">
                    {!propertyData?.propertyDetails ? (
                        <div className="p-6">
                            <div className="bg-yellow-50 border-l-4 border-yellow-400 p-4 mb-6">
                                <div className="flex">
                                    <div className="flex-shrink-0">
                                        <svg className="h-5 w-5 text-yellow-400" viewBox="0 0 20 20" fill="currentColor">
                                            <path fillRule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                                        </svg>
                                    </div>
                                    <div className="ml-3">
                                        <p className="text-sm text-yellow-700">
                                            The following information will need to be manually entered:
                                        </p>
                                        <ul className="mt-2 text-sm text-yellow-700 list-disc list-inside">
                                          {/* eslint-disable-next-line */}
                                            <li>Property County</li>
                                            {/* eslint-disable-next-line */}
                                            <li>
                                                Property Legal Description
                                                <a 
                                                    href='https://arl.colorado.gov/chapter-13-land-identification-and-real-property-descriptions' 
                                                    className="text-blue-500 ml-1"
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                >More Info</a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div className="space-y-4">
                                <div>
                                    <label htmlFor="propertyCounty" className="block text-sm font-medium text-slate-700">Property County</label>
                                    <input
                                        type="text"
                                        id="propertyCounty"
                                        className="mt-1 block px-2 py-1 w-full rounded-md border-slate-300 shadow-sm focus:border-shi-green focus:ring-shi-green sm:text-sm"
                                        placeholder="Enter property county"
                                        value={formData.propertyCounty || ''}
                                        onChange={(e) => setFormData(prev => ({ ...prev, propertyCounty: e.target.value }))}
                                    />
                                </div>
                                <div>
                                    <label htmlFor="propertyDescription" className="block text-sm font-medium text-slate-700">Property Legal Description</label>
                                    <textarea
                                        id="propertyDescription"
                                        rows={4}
                                        className="mt-1 block w-full px-2 py-1 rounded-md border-slate-300 shadow-sm focus:border-shi-green focus:ring-shi-green sm:text-sm"
                                        placeholder="Enter property legal description"
                                        value={formData.propertyDescription || ''}
                                        onChange={(e) => setFormData(prev => ({ ...prev, propertyDescription: e.target.value }))}
                                    />
                                </div>
                            </div>
                        </div>
                    ) : (
                        <>
                            <div className="bg-white rounded-lg w-full items-center flex-col flex">
                                {homeImage && <img className="w-[375px] md:w-[750px] h-[125px] md:h-[300px] rounded-tl-[10px] rounded-tr-[10px]" src={homeImage} alt="Street View" />}
                            </div>
                            <div className="p-5 border-b border-slate-200">
                                <div className="grid grid-cols-2 md:grid-cols-5 text-center md:text-left">
                                    <div>
                                        <span className="text-sm text-slate-600 block">List Price</span>
                                        <h2 className="text-lg md:text-xl font-semibold">{formattedPrice}</h2>
                                    </div>
                                    <div>
                                        <span className="text-sm text-slate-600 block">Beds / Baths</span>
                                        <h2 className="text-lg md:text-xl font-semibold">
                                            {propertyData?.propertyDetails?.resoFacts?.bedrooms || 'N/A'} bd / {propertyData?.propertyDetails?.resoFacts?.bathrooms || 'N/A'} ba
                                        </h2>
                                    </div>
                                    <div>
                                        <span className="text-sm text-slate-600 block">Living SqFt</span>
                                        <h2 className="text-lg md:text-xl font-semibold">
                                            {propertyData?.propertyDetails?.livingAreaValue ? `${propertyData.propertyDetails?.livingAreaValue.toLocaleString()} sqf` : 'N/A'}
                                        </h2>
                                    </div>
                                    <div>
                                        <span className="text-sm text-slate-600 block">Year Built</span>
                                        <h2 className="text-lg md:text-xl font-semibold">
                                            {propertyData?.propertyDetails?.yearBuilt || 'N/A'}
                                        </h2>
                                    </div>
                                    <div>
                                        <div className={`rounded-xl text-sm items-center inline-flex justify-center w-auto p-1 px-3 ${
                                            status === 'For Sale' ? 'bg-green-200 text-green-600' :
                                            status === 'Pending' ? 'bg-yellow-50 text-yellow-700' :
                                            status === 'Sold' ? 'bg-blue-200 text-blue-600' :
                                            status === 'Off Market' ? 'bg-slate-200 text-black' : ''
                                        }`}>
                                            {status === "For Sale" ? "For Sale" :
                                            status === 'Pending' ? "Pending" :
                                            status === 'Sold' ? "Sold" :
                                            status === 'Off Market' ? "Off Market" : ''}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="p-5">
                                {propertyData && (
                                    <div className="grid grid-cols-2 mb-5 w-full gap-5 md:gap-28 ">
                                        <div className="flex flex-col">
                                            {propertyData?.propertyDetails && (
                                                <div className='inline-flex mb-5'>
                                                    {isMobile ? <AvatarSVG width={18} height={18}/> : <AvatarSVG width={24} height={24}/>}
                                                    <div className='flex flex-col gap-2'>
                                                        <p className='text-sm px-2  text-slate-600'>Listing Agent</p>
                                                        <div className='inline-flex items-center'>
                                                            <span className='text-[12px] md:text-[16px] md:pl-2 pr-1.5 font-semibold'>{propertyData?.propertyDetails?.attributionInfo?.agentName}</span>
                                                            {isMobile ? '' : '\u2022'}
                                                            <span className='pl-.5 md:pl-1.5 text-[12px] md:text-[16px] text-slate-600'>{formatPhoneNumber(propertyData?.propertyDetails?.attributionInfo?.agentPhoneNumber)}</span>
                                                        </div>
                                                        <span className='text-[12px] md:text-[16px] md:px-2 font-semibold'>{propertyData?.propertyDetails?.attributionInfo?.brokerName}</span>
                                                        <span className='text-[12px] md:text-[16px] md:px-2 font-semibold'>{propertyData?.propertyDetails?.attributionInfo?.agentEmail}</span>
                                                    </div>
                                                </div>
                                            )}

                                            <div className='inline-flex mb-5'>
                                                {isMobile ? <BedroomSVG width={18} height={18}/> : <BedroomSVG width={24} height={24}/>}
                                                <div className='flex flex-col gap-2 '>
                                                    <p className='text-sm px-2 text-slate-600'>Property Info</p>
                                                    <p className="pl-2 text-[12px] md:text-[16px]"><span className="text-slate-600 text-[12px] md:text-[16px]">Garage: </span><strong>{propertyData?.propertyDetails?.hasGarage === true ? 'Yes' : 'No'}</strong></p>
                                                    {/* <p className="pl-2 text-[12px] md:text-[16px]"><span className="text-slate-600 text-[12px] md:text-[16px]">Heating: </span><strong>{propertyData?.propertyDetails?.heating[0] || 'N/A'}</strong></p> */}
                                                </div>
                                            </div>

                                            <div className='inline-flex mb-5'>
                                                {isMobile ? <MoneySVG width={18} height={18}/> : <MoneySVG width={24} height={24}/>}
                                                <div className='flex flex-col gap-2 '>
                                                    <div className='inline-flex items-center'>
                                                        <p className='text-sm px-2 text-slate-600'>Tax Info</p>
                                                    </div>
                                                    <p className="text-[12px] md:text-[16px] px-2 font-semibold">{formattedTaxPrice}</p>
                                                </div>
                                            </div>

                                        </div>
                                        <div className="flex flex-col">
                                            <div className='inline-flex mb-5'>
                                                {isMobile ? <PeopleSVG width={18} height={18}/> : <PeopleSVG width={24} height={24}/>}
                                                <div className='flex flex-col gap-2'>
                                                    <p className='text-sm px-2  text-slate-600'>Sellers</p>
                                                    <p className="text-[12px] md:text-[16px] px-2 font-semibold">{propertyData?.propertyDetails?.realieData?.property?.ownerName}</p>
                                                    {/* <p className='text-[12px] md:text-[16px] px-2 font-semibold'>{propertyData?.propertyDetails?.ownerInfo?.owner2FullName}</p> */}
                                                </div>
                                            </div>

                                            {(propertyData?.propertyDetails?.priceHistory?.length > 0) && (
                                            <div className='inline-flex mb-5'>
                                                {isMobile ? <TransactionSVG width={18} height={18}/> : <TransactionSVG width={24} height={24}/>}
                                                <div className='flex flex-col gap-2 '>
                                                <p className='text-sm px-2 text-slate-600'>Price History</p>
                                                    <p className="pl-2 text-[12px] md:text-[16px]"><span className="text-slate-600 text-[12px] md:text-[14px]">{formatDate(propertyData?.propertyDetails?.priceHistory?.[0]?.date) + ' '} {propertyData?.propertyDetails?.priceHistory?.[0]?.event + ' '} </span><strong className="text-black">{formatPrice(propertyData?.propertyDetails?.priceHistory?.[0]?.price)}</strong></p>
                                                    <p className="pl-2 text-[12px] md:text-[16px]"><span className="text-slate-600 text-[12px] md:text-[14px]">{formatDate(propertyData?.propertyDetails?.priceHistory?.[1]?.date) + ' '} {propertyData?.propertyDetails?.priceHistory?.[1]?.event + ' '} </span><strong className="text-black">{formatPrice(propertyData?.propertyDetails?.priceHistory?.[1]?.price)}</strong></p>
                                                    <p className="pl-2 text-[12px] md:text-[16px]"><span className="text-slate-600 text-[12px] md:text-[14px]">{formatDate(propertyData?.propertyDetails?.priceHistory?.[2]?.date) + ' '} {propertyData?.propertyDetails?.priceHistory?.[2]?.event + ' '} </span><strong className="text-black">{formatPrice(propertyData?.propertyDetails?.priceHistory?.[2]?.price)}</strong></p>
                                                </div>
                                            </div>
                                        )}

                                        </div>
                                    </div>
                                )}
                            </div>
                        </>
                    )}
                </div>
                <div className="w-full h-[50px] sticky bottom-0 bg-white z-10 flex items-center justify-between md:justify-center gap-10 md:gap-56 px-4 border-t border-slate-200">
                    <button 
                        className="w-[100px] md:w-[150px] justify-center text-center text-shi-green bg-white border-white text-[16px] md:text-lg font-normal font-['Inter'] p-1.5 rounded-md border hover:bg-slate-200 items-start flex" 
                        onClick={handleBack}
                    >
                        Back
                    </button>
                    <button 
                        className="w-[100px] md:w-[150px] justify-center text-center text-white bg-shi-green text-[16px] md:text-lg font-normal font-['Inter'] p-1.5 rounded-md border hover:bg-green-950 items-start flex" 
                        onClick={handleBuildOfferClick}
                    >
                        Build Offer
                    </button>
                </div>
            </div>
        </div>
    )
}

export default NewResultsCard; 